"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GeodesPreview1_exports = {};
__export(GeodesPreview1_exports, {
  default: () => GeodesPreview1_default
});
module.exports = __toCommonJS(GeodesPreview1_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.16016 5.25C7.62891 5.25 8.02604 5.08724 8.35156 4.76172C8.67708 4.4362 8.83984 4.04557 8.83984 3.58984C8.83984 3.12109 8.67708 2.72396 8.35156 2.39844C8.02604 2.07292 7.62891 1.91016 7.16016 1.91016C6.70443 1.91016 6.3138 2.07292 5.98828 2.39844C5.66276 2.72396 5.5 3.12109 5.5 3.58984C5.5 4.04557 5.66276 4.4362 5.98828 4.76172C6.3138 5.08724 6.70443 5.25 7.16016 5.25ZM13.8398 5.25C14.2956 5.25 14.6862 5.08724 15.0117 4.76172C15.3372 4.4362 15.5 4.04557 15.5 3.58984C15.5 3.12109 15.3372 2.72396 15.0117 2.39844C14.6862 2.07292 14.2956 1.91016 13.8398 1.91016C13.3711 1.91016 12.974 2.07292 12.6484 2.39844C12.3229 2.72396 12.1602 3.12109 12.1602 3.58984C12.1602 4.04557 12.3229 4.4362 12.6484 4.76172C12.974 5.08724 13.3711 5.25 13.8398 5.25ZM15.5 10.25C15.5 10.7057 15.3372 11.0964 15.0117 11.4219C14.6862 11.7474 14.2956 11.9102 13.8398 11.9102C13.3711 11.9102 12.974 11.7474 12.6484 11.4219C12.3229 11.0964 12.1602 10.7057 12.1602 10.25C12.1602 9.79427 12.3229 9.40365 12.6484 9.07812C12.974 8.7526 13.3711 8.58984 13.8398 8.58984C14.2956 8.58984 14.6862 8.7526 15.0117 9.07812C15.3372 9.40365 15.5 9.79427 15.5 10.25ZM7.16016 11.9102C7.62891 11.9102 8.02604 11.7474 8.35156 11.4219C8.67708 11.0964 8.83984 10.7057 8.83984 10.25C8.83984 9.79427 8.67708 9.40365 8.35156 9.07812C8.02604 8.7526 7.62891 8.58984 7.16016 8.58984C6.70443 8.58984 6.3138 8.7526 5.98828 9.07812C5.66276 9.40365 5.5 9.79427 5.5 10.25C5.5 10.7057 5.66276 11.0964 5.98828 11.4219C6.3138 11.7474 6.70443 11.9102 7.16016 11.9102ZM8.83984 16.9102C8.83984 17.3789 8.67708 17.776 8.35156 18.1016C8.02604 18.4271 7.62891 18.5898 7.16016 18.5898C6.70443 18.5898 6.3138 18.4271 5.98828 18.1016C5.66276 17.776 5.5 17.3789 5.5 16.9102C5.5 16.4544 5.66276 16.0638 5.98828 15.7383C6.3138 15.4128 6.70443 15.25 7.16016 15.25C7.62891 15.25 8.02604 15.4128 8.35156 15.7383C8.67708 16.0638 8.83984 16.4544 8.83984 16.9102ZM13.8398 18.5898C14.2956 18.5898 14.6862 18.4271 15.0117 18.1016C15.3372 17.776 15.5 17.3789 15.5 16.9102C15.5 16.4544 15.3372 16.0638 15.0117 15.7383C14.6862 15.4128 14.2956 15.25 13.8398 15.25C13.3711 15.25 12.974 15.4128 12.6484 15.7383C12.3229 16.0638 12.1602 16.4544 12.1602 16.9102C12.1602 17.3789 12.3229 17.776 12.6484 18.1016C12.974 18.4271 13.3711 18.5898 13.8398 18.5898Z",
      fill: "currentColor"
    }
  )
);
const SvgGeodesPreview1 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var GeodesPreview1_default = SvgGeodesPreview1;
